'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakpointCodes = exports.default = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _config = require('./config');

var _customEventConstructorPolyfill = require('./custom-event-constructor-polyfill');

var _customEventConstructorPolyfill2 = _interopRequireDefault(_customEventConstructorPolyfill);

var _highDPIWorkaround = require('./high-DPI-workaround');

var _highDPIWorkaround2 = _interopRequireDefault(_highDPIWorkaround);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _customEventConstructorPolyfill2.default)();

var breakpointCurrent = void 0;

var onMqlChange = function onMqlChange(breakpoint) {
    var event = new CustomEvent('rpBreakpointsSwitch', {
        bubbles: true,
        detail: {
            breakpoint: breakpoint,
            breakpointPrevious: breakpointCurrent
        }
    });
    window.dispatchEvent(event);
};

var handleMql = function handleMql(mql, elem) {
    if (mql.matches) {
        onMqlChange(elem);
        breakpointCurrent = elem;
    }
};

_config.config.forEach(function (elem) {
    var newMql = window.matchMedia(elem.media);
    if (newMql.matches) {
        breakpointCurrent = elem;
    }

    newMql.addListener(function (mql) {
        handleMql(mql, elem);
    });
});

var init = function init() {
    return console.warn( // eslint-disable-line
    'rp-mq-breakpoints init() is deprecated.\n    Please, do not use it. Component initialized automatically.');
};

var current = function current() {
    return breakpointCurrent || (0, _highDPIWorkaround2.default)(breakpointCurrent);
};

var getBreakpointByCode = function getBreakpointByCode(code) {
    var codeObj = null;

    if (!~(0, _values2.default)(_config.breakpointCodes).indexOf(code)) {
        throw new TypeError('Code ' + code + ', that you have passed is not valid.\n            Please, read the docs: https://stash.rp-dev.com/projects/SHAR/repos/rp-mq-breakpoints/browse');
    } else {
        codeObj = _config.config.filter(function (breakpoint) {
            return breakpoint.code === code;
        })[0];
    }

    return codeObj;
};

var mqBreakpoints = {
    init: init,
    current: current,
    getBreakpointByCode: getBreakpointByCode
};

exports.default = mqBreakpoints;
exports.breakpointCodes = _config.breakpointCodes;


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/index.js
// module id = 1709
// module chunks = 0